/**
 * Cookie consent preferences — localStorage-backed consent state.
 * Recreated after accidental deletion. The Codex coder will expand this.
 */

export interface ConsentPreferences {
  essential: boolean;
  analytics: boolean;
  marketing: boolean;
  functional?: boolean;
  consentedAt: string;
  updatedAt?: string;
}

const STORAGE_KEY = "ease_consent_preferences";

export function getStoredConsentPreferences(): ConsentPreferences | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as ConsentPreferences;
  } catch {
    return null;
  }
}

export function persistConsentPreferences(prefs: ConsentPreferences): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({
      ...prefs,
      updatedAt: new Date().toISOString(),
    }));
  } catch {
    // localStorage unavailable (SSR, private browsing)
  }
}

export function upgradeLegacyConsentStorage(): ConsentPreferences | null {
  // Migrate from old cookie-based consent to localStorage if needed
  try {
    const legacy = document.cookie.split(";").find((c) => c.trim().startsWith("ease_consent="));
    if (legacy) {
      const value = legacy.split("=")[1];
      if (value === "all") {
        const prefs: ConsentPreferences = {
          essential: true,
          analytics: true,
          marketing: true,
          consentedAt: new Date().toISOString(),
        };
        persistConsentPreferences(prefs);
        document.cookie = "ease_consent=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        return prefs;
      }
    }
    return null;
  } catch {
    return null;
  }
}
